module.exports = __webpack_public_path__ + "img/logo_cliente.2baee312.png";